// src/utils/clientLabel.js
import { formatNANP } from "./phone";

export function formatClientLabel(client, showPhone = true) {
  const name =
    client?.full_name ||
    `${client?.first_name || ""} ${client?.last_name || ""}`.trim() ||
    `Client #${client?.id ?? ""}`;
  if (showPhone && client?.phone) {
    return `${name} - ${formatNANP(client.phone)}`;
  }
  return name;
}
